'use strict';

angular.module('translations').directive('alTranslate', [
    'Translate', '$timeout',
    function (Translate, $timeout) {
        return {
            restrict: 'A',
            scope   : {
                by    : '@alTranslateBy', // user id
                from  : '@alTranslateFrom', // source language
                to    : '@alTranslateTo', // destination language
                input : '@alTranslateInput', // input variable
                output: '=alTranslateOutput', // output variable
                error : '=alErrorMessage' // error message variable
            },
            link    : function ($scope, $element) {
                $element.attr('disabled', 'disabled');
                var canBeTranslated = false;
                var processing = false;

                /**
                 * Returns bing compatible language code. If its chinese then it return entire code.
                 * For rest of the languages it return 2 first characters eg. en-gb => en.
                 * Its copy of same method from backend.
                 *
                 * @param iso6391code
                 * @returns {string}
                 */
                var getBingCompatibleLanguageCode = function (iso6391code) {
                    var exceptions = [
                        'tlh-Qaak',
                        'zh-CHS',
                        'zh-CHT',
                        'mww'
                    ];

                    if (exceptions.indexOf(iso6391code) > -1) {
                        return iso6391code;
                    }

                    return iso6391code.substr(0, 2);
                };


                $scope.$watch('input', function() {
                    $timeout(function(){
                        if($scope.input === '') {
                            $element.attr('disabled', 'disabled');
                        } else {
                            $element.attr('disabled', false);
                        }
                    });
                });

                /**
                 * Click event listener.
                 */
                $element.on('click', function () {
                    Translate.options({
                        mobileAppId: $scope.by
                    }, function (response) {
                        if(!processing){
                            $timeout(function(){
                                if (
                                    response.enums.languages[getBingCompatibleLanguageCode($scope.from)] &&
                                    response.enums.languages[getBingCompatibleLanguageCode($scope.to)]
                                ) {
                                    var $label = angular.element($element[0].querySelector('span'));
                                    var originalLabel = $label.text();
                                    processing = true;
                                    $label.text('Processing...');
        
                                    var query = {
                                        mobileAppId: $scope.by
                                    };
                                    var data = {
                                        from: $scope.from,
                                        to  : $scope.to,
                                        text: $scope.input
                                    };
        
        
                                    Translate.create(
                                        query,
                                        data,
                                        function (resource) {
                                            $scope.output = resource.output;
                                            $label.text(originalLabel);
                                            processing = false;
                                        },
                                        function() {
                                            $label.text(originalLabel);
                                            processing = false;
                                        }
                                    );
                                    $scope.error = '';
                                    return;
                                }
                                $scope.error = 'Sorry this language is not supported for Machine Translations.' +
                                '<a href=#!/supported-machine-translations >Supported Machine Translations</ a>';
                                $scope.$apply();
        
                                return;
                            });
                        }
                    });
                });
            }
        };
    }
]);
